import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import Text from '@rotaready/frecl/build/Text';

const Element = styled.blockquote`
  border-left: 2px solid ${({ theme: { colors } }) => colors.brand160};
  margin: 0;
  padding-left: 40px;
`;

const Footer = styled.footer`
  margin-top: 20px;
`;

const Blockquote = ({ text, attribution }) => (
  <Element>
    <Text text={text} size="xl" uistyle="brand160" weight={600} />
    {attribution && (
      <Footer>
        <Text text={attribution} size="xl" uistyle="brand160" />
      </Footer>
    )}
  </Element>
);

Blockquote.propTypes = {
  text: PropTypes.string.isRequired,
  attribution: PropTypes.string,
};

Blockquote.defaultProps = {
  attribution: '',
};

export default Blockquote;
